export const DISABLED_STOCK_OPTIONS_UPLOAD_FLOW_MPV_IDS = [
  'raisedFoilBusinessCards',
  'raisedFoilSwingTags'
]
